import { Link } from 'react-router-dom';

import { AnimationShell, Container, Typography } from '@/components';

export function NotFoundPage() {
  return (
    <Container size="lg" className="py-12 flex flex-col items-center justify-center space-y-8 text-center">
      <AnimationShell type="scale" className="flex flex-col items-center justify-center space-y-8 text-center">
        <Typography as="h1" size="heading-1" color="primary" weight="semibold">
          <b>Error 404</b> <small>Page not found!</small>
        </Typography>

        <Typography as="p" size="body-2" color="secondary" align="center">
          It seems that we have reached a dead end. There is nothing here, but your next great page is only a click
          away:
        </Typography>

        <Link to="/" className="cursor-pointer text-primary-700 transition hover:underline hover:underline-offset-2">
          <Typography as="span" size="body-2" color="inherit">
            Back to home
          </Typography>
        </Link>
      </AnimationShell>
    </Container>
  );
}
